import { useState } from "react";
import { useFetch } from "@/lib/hooks";
import { ACTIVE } from "@/lib/format";
import { Empty, PageHead } from "@/components/common";
import { JobRow } from "@/pages/user/UserJobs";

export default function WorkerHistory() {
  const { data } = useFetch("/jobs/worker", { live: (e) => e.type === "job" });
  const [tab, setTab] = useState("running");
  const list = (data || []).filter((j) => (tab === "running" ? ACTIVE.includes(j.status) : !ACTIVE.includes(j.status)));
  return (
    <div data-testid="worker-history-page">
      <PageHead title="Riwayat Pekerjaan" sub="Pantau pekerjaan berjalan & selesai" />
      <div className="inline-flex p-1 bg-slate-100 rounded-full mb-4">
        {[["running", "Berjalan"], ["done", "Selesai"]].map(([k, l]) => (
          <button key={k} data-testid={`history-tab-${k}`} onClick={() => setTab(k)}
            className={`px-5 py-1.5 rounded-full text-sm font-bold transition-colors ${tab === k ? "bg-amber-500 text-white" : "text-slate-600"}`}>{l}</button>
        ))}
      </div>
      <div className="space-y-3" data-testid="worker-history-list">
        {!data ? <div className="h-24 bg-slate-200 rounded-2xl animate-pulse" /> :
          list.length === 0 ? <Empty title="Tidak ada pekerjaan" /> : list.map((j) => <JobRow key={j.id} j={j} />)}
      </div>
    </div>
  );
}
